<template>
  <!-- 微信支付政企结算弹窗 -->
  <el-dialog
    title="微信快捷安全支付"
    :visible.sync="dialogVisible"
    width="440px"
    @open="open"
    :before-close="handleClose"
    custom-class="gov-pay-dialog"
    destroy-on-close
  >
    <div class="pay-modal-content">
      <div class="pay-amount-box">
        <span class="label">应付金额：</span>
        <span class="currency">￥</span>
        <span class="amount">{{ pay_amount ? pay_amount.toFixed(2) : '0.00' }}</span>
      </div>

      <div class="qrcode-wrapper">
        <div id="payQrcode"></div>
        <div class="scan-mask" v-if="loading">
          <i class="el-icon-loading"></i>
          <span>正在生成支付码...</span>
        </div>
      </div>

      <div class="pay-tip-bar">
        <i class="el-icon-camera"></i>
        <span>请使用微信 App 扫一扫二维码完成对公/快捷支付</span>
      </div>

      <div class="pay-security-note">
        <i class="el-icon-circle-check"></i>
        <span>财付通专线认证 · 支付成功后自动回跳确认结果</span>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { weiXinNativePay, getOrderStatus } from "@/api/platform";
import QRCode from "qrcodejs2";

export default {
  name: "WxPay",
  props: {
    pay_amount: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      dialogVisible: false,
      loading: true,
      order_num: null,
      timer: null,
    };
  },
  methods: {
    async open() {
      this.loading = true;
      try {
        const { result } = await weiXinNativePay({
          sign: "kePuTe",
          goods_text: "科普特商城采购",
          pay_amount: 0.01,
        });
        this.order_num = result.data.order_num;
        this.$nextTick(() => {
          this.GenerateQRcode(result.data.code_url);
          this.loading = false;
        });
        this.getOrderStatus();
      } catch (e) {
        this.loading = false;
        this.$message.error('创建微信支付订单失败，请稍后重试');
      }
    },
    GenerateQRcode(val) {
      const container = document.getElementById("payQrcode");
      if (container) {
        container.innerHTML = "";
      }
      new QRCode("payQrcode", {
        text: val,
        width: 180,
        height: 180,
        colorDark: "#0f172a",
        colorLight: "#ffffff",
        correctLevel: QRCode.CorrectLevel.H,
      });
    },
    getOrderStatus() {
      const { order_num } = this;
      this.timer = setInterval(async () => {
        try {
          const { result } = await getOrderStatus({
            order_num,
          });
          if (result && result.data && result.data.status === 2) {
            clearInterval(this.timer);
            this.$message.success("微信支付成功，正在确认订单...");
            this.dialogVisible = false;
            setTimeout(() => {
              this.$emit("wxPaySuccess");
            }, 1500);
          }
        } catch (e) {
          // ignore polling error
        }
      }, 3000);
    },
    handleClose() {
      if (this.timer) {
        clearInterval(this.timer);
      }
      this.dialogVisible = false;
    },
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style lang="less" scoped>
@import "../assets/css/var.less";

.pay-modal-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 16px 20px;

  .pay-amount-box {
    margin-bottom: 20px;
    display: flex;
    align-items: baseline;

    .label {
      font-size: 14px;
      color: #64748b;
    }

    .currency {
      font-size: 16px;
      font-weight: 700;
      color: #e11d48;
    }

    .amount {
      font-size: 26px;
      font-weight: 800;
      color: #e11d48;
      letter-spacing: -0.5px;
    }
  }

  .qrcode-wrapper {
    position: relative;
    padding: 12px;
    background: #ffffff;
    border: 2px solid #e2e8f0;
    border-radius: 12px;
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);

    #payQrcode {
      width: 180px;
      height: 180px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .scan-mask {
      position: absolute;
      inset: 0;
      background: rgba(255, 255, 255, 0.9);
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      font-size: 12px;
      color: #64748b;

      i {
        font-size: 24px;
        color: @brandPrimary;
      }
    }
  }

  .pay-tip-bar {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 18px;
    font-size: 13px;
    font-weight: 600;
    color: #10b981;

    i {
      font-size: 15px;
    }
  }

  .pay-security-note {
    display: flex;
    align-items: center;
    gap: 5px;
    margin-top: 14px;
    font-size: 11px;
    color: #94a3b8;

    i {
      color: #10b981;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wxPay.vue